
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class FractalMandalasEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const iterations = Math.floor(4 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const drawMandala = (x: number, y: number, r: number, level: number) => {
            if (level <= 0) return;

            ctx.beginPath();
            ctx.arc(x, y, r, 0, Math.PI * 2);
            ctx.stroke();

            const petals = 6;
            for (let i = 0; i < petals; i++) {
                const angle = (i / petals) * Math.PI * 2 + curTime * 0.5;
                const px = x + Math.cos(angle) * r;
                const py = y + Math.sin(angle) * r;
                drawMandala(px, py, r * 0.45, level - 1);
            }
        };

        const draw = () => {
            ctx.lineWidth = 1 * scale;
            drawMandala(0, 0, 200 * scale * (1 / (layerIndex + 1)), iterations);
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
